export default __webpack_public_path__ + "static/media/nine_of_pentacles.3de1c3ad.png";